import React, { Fragment } from 'react';

import { CheckCircleIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

export default ()=> (
  <Fragment>
     Duplicated subpage successfully
  </Fragment>
);
